<template>
	<div style="background-color: #fff;min-height: 100vh;padding: 1vh 1vw;">
		<div>
			<div style="margin: 1vh 2vw 2vh 2vw;display: flex;">
				<!-- <el-button :disabled="TableUploadedDisabled" plain @click="createWindow=true" type="primary">导入</el-button> -->
				<el-upload :disabled="TableUploadedDisabled" :limit="1" action="https://open.jfcorp.cn/express/uploadFile"
					:data="{'fileClass':'calculateBill'}" :on-success="TableUploadedSuccess" :show-file-list="false"
					accept=".xlsx">
					<el-button :disabled="TableUploadedDisabled" type="primary">上传原始数据</el-button>
				</el-upload>
				<el-button style="left: 2%;position: relative;" :disabled="!TableUploadedDisabled"
					@click="saveBillWindow=true" type="primary">保存为客户账单</el-button>
				<el-button type="text" @click="showErrorDrawer=true" v-if="errorList_.length>0"
					style="left: 2rem;position: relative;">查看错误列表</el-button>
			</div>
		</div>
		<!--计费错误的显示列表-->
		<el-drawer title="错误列表" v-model="showErrorDrawer" direction="rtl" :before-close="handleClose">
			<div v-for="(item,i) in errorList_" :key="i" style="margin-top: 1em;">{{item}}</div>
		</el-drawer>
		<!--账单生成弹窗-->
		<div>
			<el-dialog title="生成账单" v-model="createWindow" width="35%" :destroy-on-close="true"
				:close-on-press-escape="false" :close-on-click-modal="false">
				<div style="margin: 0 0 0 10%;" class="calculateFreightForm">
					<el-form ref="form" label-position="left" label-width="6em" style="width: 80%;"
						:model="calculateFreightForm">
						<el-form-item label="计费价格表">
							<el-select v-model="calculateFreightForm['priceListId']" filterable placeholder="请选择计费价格表"
								clearable>
								<el-option v-for="item in priceList" :key="item.priceListId" :label="item.priceListName"
									:value="item.priceListId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="客户名称">
							<el-select v-model="calculateFreightForm['column']['customerName']" filterable
								placeholder="请选择'客户编码/结算对象名称'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="店铺名称">
							<el-select v-model="calculateFreightForm['column']['shopName']" filterable
								placeholder="请选择'店铺名称'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="运单号码">
							<el-select v-model="calculateFreightForm['column']['waybillNo']" filterable
								placeholder="请选择'运单号'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="计费重量">
							<el-select v-model="calculateFreightForm['column']['chargedWeight']" filterable
								placeholder="请选择'计费重量'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="计费目的地">
							<el-select v-model="calculateFreightForm['column']['destination']" filterable
								placeholder="请选择'计费目的地'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="目的网点">
							<el-select v-model="calculateFreightForm['column']['destinationOrg']" filterable
								placeholder="请选择'目的网点'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="服务产品">
							<el-select v-model="calculateFreightForm['column']['serviceProducts']" filterable
								placeholder="请选择'产品服务类型'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="成本金额">
							<el-select v-model="calculateFreightForm['column']['cost']" filterable
								placeholder="请选择'成本金额'在表格中所在列名">
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="备注">
							<el-select v-model="calculateFreightForm['column']['remark']" filterable
								placeholder="选择'备注'在表格中所在列名,一般留空">
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="账单日期">
							<el-select v-model="calculateFreightForm['column']['date']" filterable
								placeholder="请选择'账单日期'在表格中所在列名" clearable>
								<el-option v-for="item in tableHeader" :key="item.index" :label="item.value"
									:value="item.index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="筛选客户">
							<el-select v-model="calculateFreightForm['screen'][0]['keyword']" multiple filterable
								allow-create default-first-option placeholder="可保留指定的客户名称行">
							</el-select>
						</el-form-item>
						<el-form-item label="筛选店铺">
							<el-select v-model="calculateFreightForm['screen'][1]['keyword']" multiple filterable
								allow-create default-first-option placeholder="可保留指定的店铺名称行"></el-select>
						</el-form-item>
						<el-form-item style="margin-top: 6vh;">
							<el-button type="primary" @click="calculateFreight(calculateFreightForm)">提交</el-button>
							<el-button @click="createWindow=false">取消</el-button>
						</el-form-item>
						<div style="text-align: center;color: red;">价格表、运单号、目的地、重量为必填项，其他可不选</div>
						<div style="text-align: center;color: red;">目的地一般为订单省份，退更件建议另计算相应费用</div>
					</el-form>
				</div>
			</el-dialog>
		</div>
		<!--修改弹窗-->
		<Div>
			<el-dialog title="修改" v-model="changeWindow" width="40%" :destroy-on-close="true"
				:close-on-press-escape="false" :close-on-click-modal="false">
				<div style="margin: 0 2%;width: 80%;">
					<el-form label-position="left" label-width="90px" :model="changeBillItemData">
						<el-form-item label="运单号" fixed="left">
							<el-input v-model="changeBillItemData.waybillNo"></el-input>
						</el-form-item>
						<el-form-item label="物料客户">
							<el-input v-model="changeBillItemData.customerName"></el-input>
						</el-form-item>
						<el-form-item label="物料店铺">
							<el-input v-model="changeBillItemData.shopName"></el-input>
						</el-form-item>
						<el-form-item label="计费目的地">
							<el-input v-model="changeBillItemData.destination"></el-input>
						</el-form-item>
						<el-form-item label="目的网点">
							<el-input v-model="changeBillItemData.destinationOrg"></el-input>
						</el-form-item>
						<el-form-item label="计费重量">
							<el-input v-model="changeBillItemData.chargedWeight"></el-input>
						</el-form-item>
						<el-form-item label="服务产品">
							<el-input v-model="changeBillItemData.serviceProducts"></el-input>
						</el-form-item>
						<el-form-item label="运费">
							<el-input v-model="changeBillItemData.totalAmount"></el-input>
						</el-form-item>
						<el-form-item label="出港成本">
							<el-input v-model="changeBillItemData.cost"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="changeBillItemData.remark"></el-input>
						</el-form-item>
						<el-form-item label="账单日期">
							<!-- <el-input v-model="changeBillItemData.date"></el-input> -->
							<el-date-picker style="width: 100%;" v-model="changeBillItemData.date" type="datetime"
								placeholder="选择日期时间"></el-date-picker>
						</el-form-item>
						<el-form-item style="margin-top: 6vh;">
							<el-button type="primary"
								@click="changeBillItemMethod(changeBillItemData,changeBillItemIndex)">保存</el-button>
							<el-button @click="changeWindow=false">取消</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
		</Div>
		<!--保存客户账单窗口-->
		<div>
			<el-dialog title="保存账单" v-model="saveBillWindow" width="35%" :destroy-on-close="true"
				:close-on-press-escape="false" :close-on-click-modal="false">
				<div style="margin: 0 5%;">
					<el-form ref="saveBillForm" label-position="left" label-width="5rem" :model="saveBillForm">
						<el-form-item label="账单名称">
							<el-input v-model="saveBillForm.billName" placeholder="请输入账单名称"></el-input>
						</el-form-item>
						<el-form-item label="结算客户">
							<el-select style="width: 100%;" v-model="saveBillForm['customerId']" filterable
								placeholder="请选择结算对象" clearable>
								<el-option v-for="item in customerList" :key="item.customerId"
									:label="item.customerName" :value="item.customerId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="margin-top: 6vh;">
							<el-button type="primary" @click="saveBill(saveBillForm)">提交</el-button>
							<el-button @click="saveBillWindow=false">取消</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
		</div>
		<!--生成账单数据展示-->
		<div style="margin-top: 2vh;">
			<el-table :data="billList" @selection-change="handleSelectionChange" height="85vh" show-summary
				:row-class-name="tableRowClassName" style="width: 100%" :cell-style="{ textAlign: 'center' }"
				:header-cell-style="{textAlign: 'center',background:'#eceff4',color:'#7f7f7f','font-weight': 500,'font-family': 'sans-serif','color': '#000'}">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" :index="$index"></el-table-column>
				<el-table-column prop="waybillNo" label="运单号" header-align="left" align="left">
					<template #default="scope">
						<div @click="waybillQueryPopup({waybillNo: scope.row.waybillNo})" style="color: #409EFF;cursor: pointer;">
							{{scope.row.waybillNo}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="customerName" label="客户名称" header-align="left" align="left"></el-table-column>
				<el-table-column prop="shopName" label="店铺名称" header-align="left" align="left"></el-table-column>
				<el-table-column prop="chargedWeight" label="计费重量" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="hdWeight" label="核对重量" header-align="center" align="center"></el-table-column>
				<el-table-column prop="lsWeight" label="揽收重量" header-align="center" align="center"></el-table-column>
				<el-table-column prop="destination" label="计费目的地" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="destinationOrg" label="目的网点" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="serviceProducts" label="服务产品" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="totalAmount" label="运费" header-align="center" align="center"></el-table-column>
				<!-- <el-table-column prop="prepaidFees" label="预付面单费" header-align="center" align="center"></el-table-column><el-table-column prop="unpaidAmount" label="待收金额" header-align="center" align="center"></el-table-column> -->
				<el-table-column prop="cost" label="出港成本" header-align="center" align="center"></el-table-column>
				<el-table-column prop="profit" label="利润" header-align="center" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
				<el-table-column prop="date" label="账单日期" header-align="center" align="center"></el-table-column>
				<el-table-column label="操作" header-align="center" align="center">
					<template #default="scope">
						<el-button type="text" @click="openChangeWindow(scope.row,scope.$index)" >修改</el-button>
						<br/>
						<el-popconfirm title="确定删除此项吗？" @confirm="deleteBillItem(scope.$index)">
							<template #reference>
								<el-button type="text">删除</el-button>
							</template>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableHeader: [], //网点账单表头字段
				priceList: [], //价格表列表
				billList: [], //显示账单列表
				//账单修改项临时存储
				changeBillItemData: {
					'waybillNo': '',
					'customerName': '',
					'shopName': '',
					'destination': '',
					'destinationOrg': '',
					'chargedWeight': '',
					'serviceProducts': '',
					'cost': '',
					'remark': '',
					'date': '',
					'totalAmount': '',
					'prepaidFees': '',
					'unpaidAmount': '',
					'errorMark': ''
				},
				//当前修改账单项索引
				changeBillItemIndex: "",
				//客户列表
				customerList: [],
				//生成账单
				calculateFreightForm: {
					priceListId: null,
					tablePath: null,
					column: {
						waybillNo: null,
						customerName: null,
						shopName: null,
						destination: null,
						destinationOrg: null,
						chargedWeight: null,
						serviceProducts: null,
						cost: null,
						remark: null,
						date: null
					},
					screen: [{
							parameterName: 'customerName',
							filteringMethod: 'CONTAIN',
							keyword: []
						},
						{
							parameterName: 'shopName',
							filteringMethod: 'CONTAIN',
							keyword: []
						}
					]
				},
				//保存账单form
				saveBillForm: {
					billName: null,
					customerId: null,
					billList: []
				},
				createWindow: false,
				//修改窗口显示与否
				changeWindow: false,
				//保存客户账单窗口显示与否
				saveBillWindow: false,
				//上传按钮是否禁用
				TableUploadedDisabled: false,
				//计费错误数据
				errorList_: [],
				//计费错误数据窗口显示
				showErrorDrawer: false
			}
		},
		methods: {
			//生成账单
			calculateFreight(calculateFreightForm) {
				console.log("开始111")
				//禁用再次上传按钮
				this.TableUploadedDisabled = true;
				// console.log(calculateFreightForm)
				if (calculateFreightForm.tablePath && calculateFreightForm.priceListId) {
					this.createWindow = false;
					const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(107, 107, 107, 0.7)'
					});
					this.apiService.post({
							modules: "calculateFreight",
							content: calculateFreightForm
						})
						.then((res) => {
							//成功
							if (res.status) {
								//计算利润-值
								var billList = res.data.billList;
								billList.forEach((item) => {
									item.profit = (item.totalAmount - item.cost).toFixed(2);
								});
								this.billList = billList;
								var errorList = res.data.errorList;
								this.errorList_ = errorList;
								if (errorList.length > 0) {
									var errHtml = ''
									for (let key in errorList) {
										errHtml = errHtml + '<div>' + errorList[key] + '</div>'
									}
									this.$alert(errHtml, '错误提示', {
										dangerouslyUseHTMLString: true
									});
								}
							}
						})
						.finally(() => {
							loading.close();
						})
			
				} else {
					this.$message.error('请选择价格表并上传模板表格');
				}
			},
			//打开修改窗口
			openChangeWindow(data, index) {
				this.changeBillItemData = data;
				this.changeBillItemIndex = index;
				this.changeWindow = true;
				// console.log(data)
				// this.$router.push({path: "/finance/quotation/details",query:{id:data.price_list_id}});
			},
			//保存修改后的账单项数据并关闭修改窗口
			changeBillItemMethod(changeBillItemData, changeBillItemIndex) {
				//判断如果错误标识=Y，然后如果目的地、计费重量、总金额、运单号都存在则视为已修正，把错误标识去掉（及其行错误颜色标识）
				if (changeBillItemData.errorMark == 'Y') {
					if (changeBillItemData.destination && changeBillItemData.chargedWeight && changeBillItemData
						.totalAmount && changeBillItemData.waybillNo) {
						changeBillItemData.errorMark = 'N'
					}
				}
				changeBillItemData['profit'] = changeBillItemData.totalAmount - changeBillItemData.cost; //更新利润
				this.billList[changeBillItemIndex] = changeBillItemData;
				this.changeWindow = false;
				// console.log(this.billList[changeBillItemIndex])
			},
			//删除账单项
			deleteBillItem(billItemIndex) {
				this.billList.splice(billItemIndex, 1);
				// console.log(this.billList)
			},
			//行颜色，错误标识=Y标成红色
			tableRowClassName({
				row
			}) {
				if (row.errorMark === 'Y') {
					return 'warning-row';
				} else {
					return '';
				}
			},
			//保存账单
			saveBill(saveBillForm) {
				// console.log(saveBillForm)
				if (saveBillForm.billList.length < 1) {
					this.$message.error('请勾选需要保存的数据');
					return
				} else {
					const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(107, 107, 107, 0.7)'
					});
					this.apiService.post({
							modules: "saveBill",
							content: saveBillForm
						})
						.then((res) => {
							//成功
							if (res.status) {
								this.$router.push('/finance/bill/customer');
							}
						})
						.finally(() => {
							loading.close();
						})
				}
			},
			//将保存账单form的账单数据修改为勾选的数据
			handleSelectionChange(selectionData) {
				/* console.log(selection) */
				this.saveBillForm.billList = selectionData;
			},

			//获取客户列表
			// getCustomerList(){
			// 	const loading = this.$loading({lock: true,text: '加载中',spinner: 'el-icon-loading',background: 'rgba(107, 107, 107, 0.7)'});
			// 	this.axios.post("",{modules:"getCustomerList",content:{}})
			// 	.then((res)=> {
			// 		if(res.data.status){
			// 			this.customerList =res.data.customerList;
			// 		}
			// 	})
			// 	.finally(()=>{
			// 		loading.close();
			// 	})
			// },
			//原始表格上传成功,获取表头
			TableUploadedSuccess(response) {
				if (response.status) {
					const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(107, 107, 107, 0.7)'
					});
					this.apiService.post({
							modules: "tableHeader",
							content: {
								'filePath': response.data.file
							}
						})
						.then((res) => {
							//成功
							if (res.status) {
								
								this.tableHeader = res.data.headerData;
								this.calculateFreightForm.tablePath = response.data.file;
								this.createWindow = true;
								//关键词匹配自动填写
								for (let item in this.tableHeader) {
									var tableHeaderName = String(this.tableHeader[item].value);
									//运单号列
									if (tableHeaderName.search('运单号') != -1) {
										this.calculateFreightForm.column.waybillNo = this.tableHeader[item].index;
									}
									//计费客户编码，优先物料k'h
									if (tableHeaderName.search('物料客户') != -1) {
										this.calculateFreightForm.column.customerName = this.tableHeader[item].index;
									} else {
										if (!this.calculateFreightForm.column.customerName) {
											if (tableHeaderName.search('客户') != -1 || tableHeaderName.search('对象') != -
												1) {
												this.calculateFreightForm.column.customerName = this.tableHeader[item]
													.index;
											}
										}
									}
									//计费店铺
									if (tableHeaderName.search('商家') != -1 || tableHeaderName.search('店铺') != -1) {
										this.calculateFreightForm.column.shopName = this.tableHeader[item].index;
									}
									//计费重量，先取下车重量一
									if (tableHeaderName.search('下车重量一') != -1) {
										this.calculateFreightForm.column.chargedWeight = this.tableHeader[item].index;
									} else {
										if (!this.calculateFreightForm.column.chargedWeight) {
											if (tableHeaderName.search('重量') != -1) {
												this.calculateFreightForm.column.chargedWeight = this.tableHeader[item]
													.index;
											}
										}
									}
								
									//计费目的地，先省份后目的地
									if (tableHeaderName.search('省份') != -1) {
										this.calculateFreightForm.column.destination = this.tableHeader[item].index;
									} else {
										if (!this.calculateFreightForm.column.destination) {
											if (tableHeaderName.search('目的地') != -1) {
												this.calculateFreightForm.column.destination = this.tableHeader[item]
													.index;
											}
										}
									}
									//目的网点
									if (tableHeaderName.search('签收网点') != -1 || tableHeaderName.search('网点') != -1 ||
										tableHeaderName.search('组织') != -1) {
										this.calculateFreightForm.column.destinationOrg = this.tableHeader[item].index;
									}
									//服务产品
									if (tableHeaderName.search('服务') != -1 || tableHeaderName.search('时效') != -1) {
										this.calculateFreightForm.column.serviceProducts = this.tableHeader[item]
											.index;
									}
									//成本
									if (tableHeaderName.search('成本') != -1 || tableHeaderName.search('金额') != -1) {
										this.calculateFreightForm.column.cost = this.tableHeader[item].index;
									}
									//账单日期，优先揽收时间
									if (tableHeaderName.search('揽收时间') != -1 || tableHeaderName.search('揽收日期') != -1) {
										this.calculateFreightForm.column.date = this.tableHeader[item].index;
									} else {
										if (!this.calculateFreightForm.column.date) {
											if (tableHeaderName.search('日期') != -1 || tableHeaderName.search('时间') != -
												1) {
												this.calculateFreightForm.column.date = this.tableHeader[item].index;
											}
										}
									}
								
								}
								// console.log(this.tableHeader)
							}
						})
						.finally(() => {
							loading.close();
						})
					/* 
					this.createForm.tablePath= response.data.file; */
				}
			},
			// create(createForm){
			// 	console.log(createForm)
			// 	if(createForm.tablePath && createForm.priceListId){
			// 		this.createWindow=false;
			// 		const loading = this.$loading({lock: true,text: '加载中',spinner: 'el-icon-loading',background: 'rgba(107, 107, 107, 0.7)'});
			// 		this.axios.post("",{modules:"calculateBill",content:createForm})
			// 		.then((res)=> {
			// 			if(res.data.status){
			// 				this.billList = res.data.billList;
			// 				var errorList =  res.data.errorList;
			// 				if(errorList){
			// 					var errHtml = ''
			// 					for(let key in errorList) {
			// 						var errHtml = errHtml+'<div>'+errorList[key]+'</div>'
			// 					}
			// 					this.$alert(errHtml, '错误提示', {dangerouslyUseHTMLString: true});
			// 				}

			// 				/* console.log(this.billList) */
			// 			}
			// 		})
			// 		.finally(()=>{
			// 			loading.close();
			// 		})
			// 	}else{
			// 		this.$message.error('请选择价格表并上传模板表格');
			// 	}
			// },


			//获取价格表列表
			getPriceList() {
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "newPriceList",
						content: {}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.priceList = res.data.priceList;
						}
					})
					.finally(() => {
						loading.close();
					})
				
			}
		},
		mounted() {
			this.getPriceList()
			/* this.getCustomerList() */
		}
	}
</script>

<style scoped>
	/deep/ .el-table .warning-row {
		background: oldlace !important;
	}

	/deep/ .calculateFreightForm .el-select {
		width: 100%;
	}
</style>